import { useEffect, useRef, useCallback } from 'react';
import {
	makeStyles
} from '@material-ui/core';

import AWS from "../utils/AWS";
import Constants from "../utils/Constants";

// custom hook to keep track of previous value of something
// https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
export function usePrevious(value) {
	const ref = useRef();
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
}

export const useEllipsis = makeStyles(theme => ({
	ellipsis: {
		"--lh": "1.5rem",
		lineHeight: "var(--lh)",

		"--max-lines": 3,
		position: "relative",
		maxHeight: "calc(var(--lh) * var(--max-lines))",
		overflow: "hidden",

		// breaks weird but otherwise content pushes things too wide
		wordBreak: "break-word",
		paddingRight: "1rem", /* space for ellipsis */

		"&:before": {
			position: "absolute",
			content: "'...'",
			bottom: 0,
			right: 0
		},

		"&:after": {
			content: "''",
			position: "absolute",
			/*
			inset-inline-end: 0;
			*/
			right: 0,
			/* missing bottom on purpose*/
			width: "1rem",
			// removed so ActivityListItem can determine if should show ellipsis or not
			// might want to move that logic elsewhere / generically available once needed again
			//height: "1.1rem",
			background: theme.palette.common.white
		}
	}
}));

export const ImgSrcRegEx = /\${img[^}]*src="([^"]*)"[^}]*}/g;
export function useHasImage(content) {
	let hasImage = ImgSrcRegEx.exec(content);

	if (hasImage && hasImage.length) {
		return true;
	}

	return false;
}

export function useReplaceImageTags(str) {
	if (str) {
		const templateStr = /\${(img[^}]*)}/g;
		const styleSizes = /width: [^;]+; height: [^;]+;/g;

		let result,
			srcs = {};

		/* eslint-disable no-cond-assign */
		while(result = ImgSrcRegEx.exec(str)) {
			if(result && result.length) {
				srcs[result[1]] = AWS.getSecureUrl(result[1]);
			}
		}
		/* eslint-disable no-cond-assign */

		Object.keys(srcs).forEach(s3Url => {
			str = str.replace(s3Url, srcs[s3Url]);
		});

		if (typeof str !== 'undefined') {
			str = str.replace(templateStr, "<$1>").replace(styleSizes, "width: 100%; height: auto;");
		}
	}

	return str;
}

export const useSelectedSubNavTab = (location, tabs=[]) => {
	return useCallback(() => {
		let tab;

		tab = tabs.filter(tab => {
			return location.pathname.indexOf(`/${tab}`) > -1;
		});

		if (!tab || tab.length ===0) {
			console.warn("useSelectedSubNavTab: tab not found in array", tabs);
		}

		return tab[0];
	}, [location.pathname, tabs]);
};

// are we on add / edit?
export const useIsEdit = (location) => {
	return location.pathname.split("/").length > 3;
};

export const useScrollTo = () => {
	return (left, top, el=window, itemOffset=0, behavior="smooth") => {
		top = top - itemOffset;
		if (Constants.ENV.IS_IE11) {
			if (el !== window) {
				el.scrollTop = top;
				el.scrollLeft = left;
			} else {
				el.scrollTo(left, top);
			}
		} else if (Constants.ENV.IS_EDGE) {
			el.scrollTo(left, top);
		} else {
			el.scrollTo({
				top: top,
				left: left,
				behavior: behavior
			});
		}
	};
};

export default {usePrevious, useEllipsis, useHasImage, useReplaceImageTags, useSelectedSubNavTab, useIsEdit, useScrollTo};